import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { AddToCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToCart.trackingInfo";
import { RemoveFromCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/removeFromCart.trackingInfo";
import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import { TrackingProductModel } from "@/services/tracking/types/trackingProduct.model";

export const toProductImpression: ModelMapper<
    Product<ProductFieldSet.Full>,
    ProductImpressionTrackingInfo
> = (product) => {
    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.productTitle,
        category:
            product.analytics.superCategoryCode ||
            product.analytics?.superCategoryCode,
        price: product.price?.currentPrice ?? 0,
        unitPrice: product.price?.currentPrice ?? 0,
        tax: "21%",
        reduction: `${product.price?.roundedDiscountPercentage ?? 0}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? ""
    };
};

export const toTrackingProduct: ModelMapper<
    Product<ProductFieldSet.Full>,
    TrackingProductModel
> = (product) => {
    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.productTitle,
        category: product.analytics?.superCategoryCode || product.brand?.code,
        price: product.price?.currentPrice ?? 0,
        unitPrice: product.price?.currentPrice ?? 0,
        tax: "21%",
        reduction: `${product.price?.roundedDiscountPercentage ?? 0}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? ""
    };
};

export const toAddToCartTrackingInfo: ModelMapper<
    { product: Product<ProductFieldSet.Full>; quantity: number },
    AddToCartTrackingInfo
> = ({ product, quantity }) => {
    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.productTitle,
        category:
            product.analytics.superCategoryCode ||
            product.analytics?.superCategoryCode,
        price: product.price?.currentPrice ?? 0,
        unitPrice: product.price?.currentPrice ?? 0,
        tax: "21%",
        reduction: `${product.price?.roundedDiscountPercentage ?? 0}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? "",
        quantity: quantity,
        url: product.url
    };
};

export const toRemoveFromCartTrackingInfo: ModelMapper<
    { product: Product<ProductFieldSet.Full>; quantity: number },
    RemoveFromCartTrackingInfo
> = ({ product, quantity }) => {
    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.productTitle,
        category:
            product.analytics.superCategoryCode ||
            product.analytics?.superCategoryCode,
        price: product.price?.currentPrice ?? 0,
        unitPrice: product.price?.currentPrice ?? 0,
        tax: "21%",
        reduction: `${product.price?.roundedDiscountPercentage ?? 0}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? "",
        quantity: quantity,
        url: product.url
    };
};
